import type { ReactNode } from 'react';

import { Timecode as CoreTimecode } from '@iconik-io/core/src/timecode';
import type { AriaProps } from '@iconik-io/shared-lib/src/react/a11y/aria';
import { zeroTimecode } from '@iconik-io/shared-lib/src/utils/constants/timecode';
import type { TimecodeOptions } from '@iconik-io/shared-lib/src/utils/get_proxy_timecode_options';

import type { FormFieldEvent } from '../../../ui/forms/types';
import {
  stringRenderer,
  type TimecodeProps,
  type TimecodeState,
} from './renderers';
import TimecodeBase from './timecode_base';

export type ValueType = number;

type Props = {
  value?: ValueType;
  timecodeOptions: TimecodeOptions;
  onChange?: (value: ValueType, event?: FormFieldEvent) => void;
  renderer?: (props: TimecodeProps, state: TimecodeState) => ReactNode;
  aria?: AriaProps;
};

export function Timecode({
  value,
  timecodeOptions,
  renderer,
  onChange,
  aria,
}: Props) {
  const handleChange = (updatedSeconds: number): void => {
    const startTimecodeObject = new CoreTimecode(timecodeOptions, {
      smpte: timecodeOptions.startTimecode ?? zeroTimecode,
    });
    const currentTime = updatedSeconds - startTimecodeObject.toSeconds();
    onChange?.(currentTime * 1000);
  };

  const valueSeconds = value ? Number(value) / 1000 : 0;

  const startTimecodeObject = new CoreTimecode(timecodeOptions, {
    smpte: timecodeOptions.startTimecode ?? zeroTimecode,
  });
  const seconds = valueSeconds + startTimecodeObject.toSeconds();

  return (
    <TimecodeBase
      value={seconds}
      timecodeOptions={timecodeOptions}
      changeValue={handleChange}
      renderer={renderer ?? stringRenderer}
      aria={aria}
    />
  );
}
